/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import CompletedTraining from "components/widgets/training/CompletedTraining";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

class CompletedTrainings extends Component {
  state = {
    filteredTrainingsData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    dataFetched: false,
    sort_by: "trName", // training name by default
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    //console.log(this.props.data);
    this.setState({ filteredTrainingsData: this.props.data.trainings });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({ filteredTrainingsData: this.props.data.trainings });
    }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredTrainingsData: this.props.data.trainings.filter((item) => {
          return Helpers.getTurkishCharaterFixedList(
            item.training.name
          ).includes(
            Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
          );
        }),
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderPager = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredTrainingsData?.length > 0
              ? this.state.filteredTrainingsData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  trType = "";
  trName = "";
  trLocation = "";
  // trStatus = "";
  trScore = "";
  trStartDate = "";
  trEndDate = "";
  trDocuments = "";
  trCertificate = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trType = "";
    this.trName = "";
    this.trLocation = "";
    this.trDocuments = "";
    this.trScore = "";
    this.trStartDate = "";
    this.trEndDate = "";
    switch (this.state.sort_by) {
      case "trType":
        this.trType = `_${this.state.sort_dir}`;
        break;
      case "trName":
        this.trName = `_${this.state.sort_dir}`;
        break;
      case "trLocation":
        this.trLocation = `_${this.state.sort_dir}`;
        break;
      case "trDocuments":
        this.trDocuments = `_${this.state.sort_dir}`;
        break;
      case "trScore":
        this.trScore = `_${this.state.sort_dir}`;
        break;
      case "trStartDate":
        this.trStartDate = `_${this.state.sort_dir}`;
        break;
      case "trEndDate":
        this.trEndDate = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredTrainingsData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trName":
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
        case "trScore":
          return this.state.sort_dir === "desc"
            ? a.score - b.score
            : b.score - a.score;
        case "trDocuments":
          return this.state.sort_dir === "desc"
            ? Number(a.hasDocument) > Number(b.hasDocument)
            : Number(b.hasDocument) > Number(a.hasDocument);
        case "trCertificate":
          try {
            return this.state.sort_dir === "desc"
              ? a.certificationNo.localeCompare(b.certificationNo)
              : b.certificationNo.localeCompare(a.certificationNo);
          } catch { }
          break;
        case "trStartDate":
          try {
            return this.state.sort_dir === "desc"
              ? new Date(a.timeplans[0]?.startDate) -
              new Date(b.timeplans[0]?.startDate)
              : new Date(b.timeplans[0]?.startDate) -
              new Date(a.timeplans[0]?.startDate);
          } catch { }
          break;
        case "trEndDate":
          try {
            return this.state.sort_dir === "desc"
              ? new Date(a.timeplans[0]?.endDate) -
              new Date(b.timeplans[0]?.endDate)
              : new Date(b.timeplans[0]?.endDate) -
              new Date(a.timeplans[0]?.endDate);
          } catch { }
          break;
        case "trType":
          return this.state.sort_dir === "desc"
            ? a.trainingMethod.label.localeCompare(b.trainingMethod.label)
            : b.trainingMethod.label.localeCompare(a.trainingMethod.label);
        default:
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
      }
      return 1;
    });

    return sorted.slice(start, end).map((t) => {
      return (
        <CompletedTraining
          key={t.key}
          t={t}
          employeeCode={this.props.data.employeeCode}
        />
      );
    });
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();
    return (
      <>
        <div>{this.renderPager()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="kayitliEgitimler"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive tgE dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trType")}
                  className={`all sorting${this.trType}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Tür">10114</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trName")}
                  className={`all sorting${this.trName}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Eğitim Adı">10115</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th className="none"></th>
                  <th
                    onClick={() => this.reOrder("trStartDate")}
                    className={`desktop sorting${this.trStartDate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10117</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trEndDate")}
                    className={`desktop sorting${this.trEndDate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10118</Trans>
                    </div>
                  </th>
                  {/* <th
                    onClick={() => this.reOrder("trStatus")}
                    className={`desktop sorting${this.trStatus}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Başarı">10120</Trans>
                    </div>
                  </th> */}
                  <th
                    onClick={() => this.reOrder("trScore")}
                    className={`desktop sorting${this.trScore}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Puan">10177</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trDocuments")}
                    className={`desktop sorting${this.trDocuments}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Dokumanlar">10178</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trCertificate")}
                    className={`desktop sorting${this.trCertificate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Sertifika">10179</Trans>
                    </div>
                  </th>
                  <th className="none"></th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
      </>
    );
  }
}

export default CompletedTrainings;
